import axiosClient from "./axiosClient";
export const getAllProjects = async (uid) => {
  const response = await axiosClient.get("/projects", {
    params: { uid },
  });
  return response.data;
};

export const getProjectCount = async (uid) => {
  const response = await axiosClient.get("/projects/count", {
    params: { uid },
  });
  return response.data;
};

export const saveProject = async (uid, project) => {
  const response = await axiosClient.post("/projects", {
    uid,
    project,
  });

  return response.data;
};

export const updateProjectTagById = async (uid, projectId, tag) => {
  const response = await axiosClient.patch(`/projects/${projectId}/tag`, {
    uid,
    tag,
  });

  return response.data;
};

export const deleteProjectById = async (uid, projectId) => {
  const response = await axiosClient.delete(`/projects/${projectId}`, {
    data: { uid },
  });
  return response.data;
};
